// extracted by mini-css-extract-plugin
module.exports = {"XCooling":"XCooling_XCooling__nI6iB"};